module.exports = __webpack_public_path__ + "img/model_58.0c0fcd9d.png";